import React from 'react'
import type { InputHTMLAttributes } from 'react'
import { cn } from '@utils/safeTs'
import { Checkmark, Close } from '@components/icons'
import styles from './FormBlurSaveInput.module.sass'
import LoadingSvg from '../Loading/Loading'

export type FormBlurSaveInputProps = {
  type?: string
  value?: string
  onChange?: (v: string) => void
  onBlur?: (v: string) => void
  disabled?: boolean
  loading?: boolean
  status?: 'default' | 'error' | 'success' // risultato del save
  variant?: 'default' | 'warning' | 'accent' // colore di sfondo
  className?: string
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

const FormBlurSaveInput = ({
  type = 'number',
  value,
  onChange,
  onBlur,
  disabled = false,
  loading = false,
  status = 'default',
  variant = 'default',
  className,
  ...rest
}: FormBlurSaveInputProps) => {

  return (
    <div
      className={cn(
        styles.root,
        styles[`root--${variant}`],
        styles[`root--${status}`],
        disabled && styles['root--disabled'],
        className
      )}
    >
      <input
        type={type}
        value={value}
        className={styles.input}
        disabled={disabled}
        aria-busy={loading ? true : undefined}
        inputMode={type === 'number' ? "numeric" : undefined}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      {loading && (
        <span className={styles.loader}><LoadingSvg /></span>
      )}
      <span className={cn(styles.icon, styles['icon--success'])} aria-hidden>
        <Checkmark />
      </span>
      <span className={cn(styles.icon, styles['icon--error'])} aria-hidden>
        <Close />
      </span>
    </div>
  )
}

export default FormBlurSaveInput
